/* APIRoutes
* Use create/retrieve/update/delete keywords for api prop name and follow the module screen hierarchy.
* if same api is used for multiple operations, define it once with the prop name in short form
*  (e.g cu, cd,cud, crud)
*/

export const APIRoutes = {
    autoInfo: {
        initialize: 'AutoInfoCatalogue/Initialise',
        catalogueTypeChange: 'AutoInfoCatalogue/CatalogueType/:CatalogueType/Change',
        catalogueEntries: {
            retrieve: 'AutoInfoCatalogue/CatalogueType/:CatalogueType/Vehicle/:VehicleId/Catalogues'
        },
        vehicleDetails: {
            retrieve: 'AutoInfoCatalogue/Vehicle/:VehicleId'
        },
        partsList: {
            retrieve: 'AutoInfoCatalogue/CatalogueType/:CatalogueType/Vehicle/:VehicleId/Catalogue/:CatalogueId/Parts',
            children: {
                retrieve: 'AutoInfoCatalogue/CatalogueType/:CatalogueType/Vehicle/:VehicleId/Catalogue/:CatalogueId/Item/:ItemId/Children'
            }
        },
        product: {
            pricingAndAvailability: {
                retrieve: 'AutoInfoCatalogue/Product/PricingAndAvailability'
            }
        },
        productDetails: {
            retrieve: 'AutoInfoCatalogue/Product/Specifications',
        },
        summary: {
            retrieve: 'AutoInfoCatalogue/Product/:ProductId/Summary'
        },
        search: {
            regoStates: 'CustomTypes/Lookup/AutoIVehicleRegoState/Search',
            vehicleSearch: 'AutoInfoCatalogue/CatalogueType/:CatalogueType/SearchVehicle',
            manualSearch: 'AutoInfoCatalogue/CatalogueType/:CatalogueTypeId/SearchVehicleByAttribute',
        },
    }
};
